var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useMemo, useState } from 'react';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { FixedSizeList } from 'react-window';
import { findBestMatch } from 'string-similarity';
import { useLanguage } from '@base/LanguageProvider';
import { ColumnMetaDataContext, ImportJobStatus, TagType, } from '@common/api';
import FSToggle from '@components/FSToggle';
import FSButton from '@components/FSButton';
import * as baobab from '@data/baobab/baobab';
import { withRoot } from '@data/baobab/withRoot';
import { useTagActions } from '@data/tag/tagActions';
import { useTimePoints } from '@data/hooks/timePoints';
import { useTagContext } from '@data/tag/tagContext';
import { useDetectDimensions, useUpdateImportJob } from '@data/importJob/importJobActions';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import { CheckBox, ThreeStateCheckBox } from '@shared/input/CheckBox';
import { Confirmation as ConfirmationModal } from '@shared/modal/Simple';
import SelectInput from '@shared/input/SelectInput';
import { ModalBody } from '@styled/Modal';
import { FormField, FormFieldLabel } from '@styled/Form';
import { globalLoadingWrapped } from './util';
var NAME_MATCH_THRESHOLD = 0.75;
var LIST_HEIGHT = 300;
var LIST_ITEM_HEIGHT = 28;
function ColumnEditModal(_a) {
    var _this = this;
    var _b, _c;
    var importJob = _a.importJob, columnIndex = _a.columnIndex;
    var columnFilter = useBranch({
        columnFilter: ['state', 'importColumnFilters', importJob.id, columnIndex],
    }).columnFilter;
    var columnMeta = importJob.metadata.columnMetas[columnIndex];
    var _d = useLanguage(), L = _d.L, excelLocalizedNumberFormat = _d.excelLocalizedNumberFormat, formatLocaleDate = _d.formatLocaleDate;
    var valueFormatter = useMemo(function () { return function (rawValue) {
        if ((columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.dataContext) === ColumnMetaDataContext.DATETIME) {
            var date = new Date(rawValue);
            return formatLocaleDate(date);
        }
        else if ((columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.dataContext) === ColumnMetaDataContext.VALUES ||
            (columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.dataContext) === ColumnMetaDataContext.TIMEPOINT) {
            if (typeof rawValue === 'number') {
                return excelLocalizedNumberFormat(rawValue);
            }
            else {
                return '';
            }
        }
        else {
            return String(rawValue);
        }
    }; }, [columnMeta, excelLocalizedNumberFormat, formatLocaleDate]);
    var tagData = useTagContext().tagData;
    var timePoints = (_b = useTimePoints().data) !== null && _b !== void 0 ? _b : [];
    var updateImportJob = useUpdateImportJob();
    var detectDimensions = useDetectDimensions();
    var _e = __read(useState((_c = columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.dataContext) !== null && _c !== void 0 ? _c : ColumnMetaDataContext.NONE), 2), dataContext = _e[0], setDataContext = _e[1];
    var _f = __read(useState(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.tableTagId), 2), tableTagId = _f[0], setTableTagId = _f[1];
    var _g = __read(useState(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.timePointId), 2), timePointId = _g[0], setTimePointId = _g[1];
    var _h = __read(useState(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.applyTagsIds), 2), applyTagsIds = _h[0], setApplyTagsIds = _h[1];
    var _j = __read(useState(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.detectedTagMap), 2), detectedTagMap = _j[0], setDetectedTagMap = _j[1];
    var _k = __read(useState(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.manualMapping), 2), manualMapping = _k[0], setManualMapping = _k[1];
    var _l = __read(useState(columnFilter !== null && columnFilter !== void 0 ? columnFilter : { hasEmptyCells: false, showEmptyCells: false, sortedValues: [], showValues: {} }), 2), columnFilterLocal = _l[0], setColumnFilterLocal = _l[1];
    useEffect(function () {
        if (columnFilter !== undefined) {
            setColumnFilterLocal(columnFilter);
        }
    }, [columnFilter]);
    var filterSelectAll = useMemo(function () {
        var allFilterValues = columnFilterLocal.hasEmptyCells
            ? __spreadArray([columnFilterLocal.showEmptyCells], __read(Object.values(columnFilterLocal.showValues)), false) : Object.values(columnFilterLocal.showValues);
        var trueCount = allFilterValues.reduce(function (previous, current) {
            if (!!current) {
                return previous + 1;
            }
            else {
                return previous;
            }
        }, 0);
        if (trueCount === allFilterValues.length) {
            // all filter values are set to "true"
            return true;
        }
        else if (trueCount === 0) {
            // all filter values are set to "false"
            return false;
        }
        else {
            // mixed "true" and "false" filter values
            return null;
        }
    }, [columnFilterLocal]);
    var dataContextOptions = useMemo(function () { return [
        { label: L('None'), value: ColumnMetaDataContext.NONE },
        { label: L('Table'), value: ColumnMetaDataContext.IDENTIFIER },
        { label: L('Value'), value: ColumnMetaDataContext.VALUES },
        { label: L('Date'), value: ColumnMetaDataContext.DATETIME },
        { label: L('Value for month'), value: ColumnMetaDataContext.TIMEPOINT },
        { label: L('Description'), value: ColumnMetaDataContext.DESCRIPTION },
        { label: L('Custom field'), value: ColumnMetaDataContext.CUSTOM },
        { label: L('Table description'), value: ColumnMetaDataContext.TAG_DESCRIPTION },
    ]; }, [L]);
    var timePointOptions = useMemo(function () { return timePoints.map(function (tp) { return ({ label: "".concat(tp.month, "/").concat(tp.year), value: tp.id }); }); }, [timePoints]);
    var applyTags = useMemo(function () {
        var e_1, _a;
        if (applyTagsIds === undefined) {
            return [];
        }
        var dimensionAndAccountTags = [];
        try {
            for (var applyTagsIds_1 = __values(applyTagsIds), applyTagsIds_1_1 = applyTagsIds_1.next(); !applyTagsIds_1_1.done; applyTagsIds_1_1 = applyTagsIds_1.next()) {
                var applyTagId = applyTagsIds_1_1.value;
                var applyTag = tagData.tagById[applyTagId];
                if (applyTag !== undefined && (applyTag.type === TagType.Account || applyTag.type === TagType.Dimension)) {
                    dimensionAndAccountTags.push(applyTag);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (applyTagsIds_1_1 && !applyTagsIds_1_1.done && (_a = applyTagsIds_1.return)) _a.call(applyTagsIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return dimensionAndAccountTags;
    }, [tagData, applyTagsIds]);
    if (columnMeta === undefined) {
        // don't render modal if column doesn't exist
        Manager.closeModal();
        return null;
    }
    var tableTag = tableTagId !== undefined ? tagData.tagById[tableTagId] : undefined;
    var importJobEditable = importJob.status === ImportJobStatus.CREATED || importJob.status === ImportJobStatus.REVERTED;
    var changeDataContext = function (e) {
        var newDataContext = e.target.value;
        if (newDataContext === null) {
            return;
        }
        setDataContext(newDataContext);
        if (newDataContext !== ColumnMetaDataContext.IDENTIFIER) {
            setTableTagId(undefined);
            setDetectedTagMap(undefined);
        }
        if (newDataContext !== ColumnMetaDataContext.TIMEPOINT) {
            setTimePointId(undefined);
        }
    };
    var changeTimePoint = function (e) {
        var targetValue = e.target.value;
        var newTimePointId = typeof targetValue === 'number' ? targetValue : undefined;
        setTimePointId(newTimePointId);
    };
    var changeTableTag = function (newTableTagId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setTableTagId(newTableTagId);
            if (newTableTagId !== undefined) {
                setDetectedTagMap({});
            }
            return [2 /*return*/];
        });
    }); };
    var addApplyTag = function (tagId) {
        var applyTagsIdsCopy = applyTagsIds === undefined ? [] : __spreadArray([], __read(applyTagsIds), false);
        applyTagsIdsCopy.push(tagId);
        setApplyTagsIds(applyTagsIdsCopy);
    };
    var removeApplyTag = function (tagId) {
        var applyTagsIdsCopy = applyTagsIds === undefined ? [] : applyTagsIds.filter(function (tId) { return tId !== tagId; });
        setApplyTagsIds(applyTagsIdsCopy);
    };
    var changeSelectAll = function () {
        var e_2, _a;
        // if all values are selected, unselect them all, else select them all
        var setFilterTo = filterSelectAll === true ? false : true;
        var columnFilterCopy = {
            hasEmptyCells: columnFilterLocal.hasEmptyCells,
            showEmptyCells: setFilterTo,
            sortedValues: columnFilterLocal.sortedValues,
            showValues: __assign({}, columnFilterLocal.showValues),
        };
        try {
            for (var _b = __values(columnFilterLocal.sortedValues), _c = _b.next(); !_c.done; _c = _b.next()) {
                var valueKey = _c.value;
                columnFilterCopy.showValues[valueKey] = setFilterTo;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        setColumnFilterLocal(columnFilterCopy);
    };
    var changeFilterItem = function (filterItem) {
        var columnFilterCopy = {
            hasEmptyCells: columnFilterLocal.hasEmptyCells,
            showEmptyCells: columnFilterLocal.showEmptyCells,
            sortedValues: columnFilterLocal.sortedValues,
            showValues: __assign({}, columnFilterLocal.showValues),
        };
        if (filterItem === null) {
            columnFilterCopy.showEmptyCells = !columnFilterCopy.showEmptyCells;
        }
        else {
            columnFilterCopy.showValues[filterItem] = !columnFilterCopy.showValues[filterItem];
        }
        setColumnFilterLocal(columnFilterCopy);
    };
    var targetTagsHandler = function (valueKey, targetTags) {
        var detectedTagMapCopy = __assign({}, detectedTagMap);
        detectedTagMapCopy[valueKey] = targetTags;
        setDetectedTagMap(detectedTagMapCopy);
    };
    var autodetectDimensions = function () {
        var e_3, _a;
        var _b, _c;
        if (tableTagId === undefined) {
            // can't detect dimensions with no table
            return;
        }
        var dimensionTags = tagData.tagsByParentId[tableTagId];
        if (dimensionTags === undefined) {
            // no dimensions
            return;
        }
        // map names and descriptions of dimensions
        var dimensionTagNames = new Array(dimensionTags.length);
        var dimensionTagDescriptions = new Array(dimensionTags.length);
        for (var i = 0; i < dimensionTags.length; i++) {
            dimensionTagNames[i] = dimensionTags[i].name.toLowerCase();
            dimensionTagDescriptions[i] = (_c = (_b = dimensionTags[i].description) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
        }
        var detectedTagMapCopy = __assign({}, detectedTagMap);
        try {
            for (var _d = __values(columnFilterLocal.sortedValues), _e = _d.next(); !_e.done; _e = _d.next()) {
                var valueKey = _e.value;
                // find best match by name
                var valueString = String(valueKey);
                var bestDimensionTagMatch = undefined;
                var bestMatchDirect = findBestMatch(valueString.toLowerCase(), dimensionTagNames);
                if (bestMatchDirect.bestMatch.rating > NAME_MATCH_THRESHOLD) {
                    bestDimensionTagMatch = dimensionTags[bestMatchDirect.bestMatchIndex];
                }
                else {
                    // low name matches, try to find best match by description
                    var bestMatchDescription = findBestMatch(valueString.toLowerCase(), dimensionTagDescriptions);
                    if (bestMatchDescription.bestMatch.rating > NAME_MATCH_THRESHOLD) {
                        bestDimensionTagMatch = dimensionTags[bestMatchDescription.bestMatchIndex];
                    }
                }
                if (bestDimensionTagMatch !== undefined) {
                    // match was found
                    var previousTagIds = detectedTagMapCopy[valueString];
                    var tagIdsCopy = previousTagIds !== undefined ? __spreadArray([], __read(previousTagIds), false) : [];
                    if (!tagIdsCopy.includes(bestDimensionTagMatch.id)) {
                        tagIdsCopy.push(bestDimensionTagMatch.id);
                    }
                    detectedTagMapCopy[valueString] = tagIdsCopy;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_3) throw e_3.error; }
        }
        setDetectedTagMap(detectedTagMapCopy);
    };
    var filterUnmapped = function () {
        var e_4, _a;
        var _b, _c;
        // copy filter
        var columnFilterCopy = {
            hasEmptyCells: columnFilterLocal.hasEmptyCells,
            showEmptyCells: columnFilterLocal.showEmptyCells,
            sortedValues: columnFilterLocal.sortedValues,
            showValues: __assign({}, columnFilterLocal.showValues),
        };
        // check table default value
        var tableHasDefaultValue = false;
        if (tableTagId !== undefined) {
            var tableTag_1 = tagData.tagById[tableTagId];
            if (tableTag_1 !== undefined && tableTag_1.defaultValue !== undefined && tableTag_1.defaultValue !== null) {
                tableHasDefaultValue = true;
            }
        }
        // show empty cells only if there is no default value
        columnFilterCopy.showEmptyCells = !tableHasDefaultValue;
        try {
            // go through values in filter
            for (var _d = __values(columnFilterLocal.sortedValues), _e = _d.next(); !_e.done; _e = _d.next()) {
                var valueKey = _e.value;
                // count detected tags for every value
                var detectedTagCountForValue = (_c = (_b = detectedTagMap === null || detectedTagMap === void 0 ? void 0 : detectedTagMap[valueKey]) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
                // show values that don't have any detected tags
                columnFilterCopy.showValues[valueKey] = detectedTagCountForValue === 0;
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_4) throw e_4.error; }
        }
        // set new filter
        setColumnFilterLocal(columnFilterCopy);
    };
    var clearTagMap = function () {
        setDetectedTagMap({});
    };
    var changeManualMapping = function (newManualMapping) {
        setManualMapping(newManualMapping);
        if (!newManualMapping) {
            setDetectedTagMap(columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.detectedTagMap);
        }
    };
    var manualMappingHandler = function () {
        var newManualMapping = !manualMapping;
        if (newManualMapping) {
            changeManualMapping(newManualMapping);
        }
        else {
            Manager.renderModal(React.createElement(ConfirmationModal, { width: 500, title: L('Confirm'), onOk: function () { return changeManualMapping(newManualMapping); } },
                React.createElement("span", null,
                    L('This action will remove all manually added mapping tags.'),
                    React.createElement("br", null),
                    L('Are you sure you want to do it?'))));
        }
    };
    var saveColumnMetaChanges = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        var currentColumnMetaCopy, columnMetasCopy, metadataCopy;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    currentColumnMetaCopy = {
                                        name: columnMeta.name,
                                        dataContext: dataContext,
                                    };
                                    if (columnMeta.dateFormat !== undefined) {
                                        currentColumnMetaCopy.dateFormat = columnMeta.dateFormat;
                                    }
                                    if (columnMeta.numberType !== undefined) {
                                        currentColumnMetaCopy.numberType = columnMeta.numberType;
                                    }
                                    if (dataContext === ColumnMetaDataContext.IDENTIFIER) {
                                        if (tableTagId !== undefined) {
                                            currentColumnMetaCopy.tableTagId = tableTagId;
                                        }
                                        if (detectedTagMap !== undefined) {
                                            currentColumnMetaCopy.detectedTagMap = detectedTagMap;
                                        }
                                        if (manualMapping !== undefined) {
                                            currentColumnMetaCopy.manualMapping = manualMapping;
                                        }
                                    }
                                    else if (dataContext === ColumnMetaDataContext.TIMEPOINT) {
                                        if (timePointId !== undefined) {
                                            currentColumnMetaCopy.timePointId = timePointId;
                                        }
                                        if (applyTagsIds !== undefined) {
                                            currentColumnMetaCopy.applyTagsIds = applyTagsIds;
                                        }
                                    }
                                    else if (dataContext === ColumnMetaDataContext.VALUES) {
                                        if (applyTagsIds !== undefined) {
                                            currentColumnMetaCopy.applyTagsIds = applyTagsIds;
                                        }
                                    }
                                    columnMetasCopy = __spreadArray([], __read(importJob.metadata.columnMetas), false);
                                    columnMetasCopy[columnIndex] = currentColumnMetaCopy;
                                    metadataCopy = __assign(__assign({}, importJob.metadata), { columnMetas: columnMetasCopy });
                                    return [4 /*yield*/, updateImportJob.mutateAsync({ id: importJob.id, metadata: metadataCopy })];
                                case 1:
                                    _a.sent();
                                    if (!(currentColumnMetaCopy.dataContext === ColumnMetaDataContext.IDENTIFIER)) return [3 /*break*/, 3];
                                    return [4 /*yield*/, detectDimensions.mutateAsync(importJob.id)];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var saveChanges = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!importJobEditable) return [3 /*break*/, 2];
                    return [4 /*yield*/, saveColumnMetaChanges()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    baobab.root.set(['state', 'importColumnFilters', importJob.id, columnIndex], columnFilterLocal);
                    Manager.closeModal();
                    return [2 /*return*/];
            }
        });
    }); };
    // offset 1 for "Select all", another 1 if "(Blank cells)" should be displayed
    var displayDataOffset = columnFilterLocal.hasEmptyCells ? 2 : 1;
    return (React.createElement(Modal, { width: '700', closeable: false },
        React.createElement(ModalHeader, { title: "".concat(L('Edit column'), " \"").concat(columnMeta.name, "\"") }),
        React.createElement(ModalBody, { className: "fs-import-column-edit" },
            React.createElement("form", { className: "form-horizontal" },
                React.createElement(SelectInput, { name: "columnType", label: L('Column type'), options: dataContextOptions, value: dataContext, onChange: changeDataContext, disabled: !importJobEditable, bottomMargin: true }),
                dataContext === ColumnMetaDataContext.TIMEPOINT && (React.createElement(SelectInput, { name: "timePointId", label: L('Month'), options: timePointOptions, value: timePointId, onChange: changeTimePoint, disabled: !importJobEditable, bottomMargin: true })),
                (dataContext === ColumnMetaDataContext.IDENTIFIER ||
                    dataContext === ColumnMetaDataContext.TAG_DESCRIPTION) && (React.createElement(Tags, { tags: tableTag !== undefined ? [tableTag] : [], filterByTypes: [TagType.Table], canUpdate: importJobEditable, afterButtonLabel: L('Table'), afterButtonLabelType: TagType.Table, select: function (newTableTagId) { return changeTableTag(newTableTagId); }, remove: function () { return changeTableTag(undefined); }, canAddOnlyOneTag: true })),
                (dataContext === ColumnMetaDataContext.VALUES ||
                    dataContext === ColumnMetaDataContext.TIMEPOINT) && (React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Variable & Dimensions')),
                    React.createElement(Tags, { canUpdate: importJobEditable, tags: applyTags, select: addApplyTag, remove: removeApplyTag, filterByTypes: [TagType.Account, TagType.Dimension] }))),
                importJobEditable && dataContext === ColumnMetaDataContext.IDENTIFIER && (React.createElement("div", { className: "fs-filter-toolbar" },
                    React.createElement(FSButton, { type: "button", "$color": "function", "$size": "small", title: L('Show unmapped'), onClick: filterUnmapped, style: { marginRight: 32 } }),
                    React.createElement("div", null,
                        React.createElement(FSToggle, { checked: manualMapping, "$size": "small", onChange: manualMappingHandler, title: L('Manual mapping'), style: { marginRight: 4 } }),
                        React.createElement(FSButton, { type: "button", "$color": "primary", "$size": "small", title: L('Clear'), onClick: clearTagMap, style: { marginRight: 4 }, disabled: !manualMapping }),
                        React.createElement(FSButton, { type: "button", "$color": "primary", "$size": "small", title: L('Autodetect'), onClick: autodetectDimensions, disabled: !manualMapping })))),
                React.createElement("div", { className: "fs-filter-toolbar" },
                    React.createElement("span", null, "".concat(L('Filter'), ":"))),
                React.createElement("div", { className: "fs-filter-box" },
                    React.createElement(FixedSizeList, { height: LIST_HEIGHT, itemCount: columnFilterLocal.sortedValues.length + displayDataOffset, itemSize: LIST_ITEM_HEIGHT, width: '100%', style: { paddingTop: 10 }, className: "tiny-scrollbars" }, function (_a) {
                        var index = _a.index, style = _a.style;
                        if (index === 0) {
                            return (React.createElement("div", { style: style },
                                React.createElement("div", { className: "filters-and-tags" },
                                    React.createElement(ThreeStateCheckBox, { value: filterSelectAll, action: function () { return changeSelectAll(); }, label: L('(Select all)') }))));
                        }
                        else if (columnFilterLocal.hasEmptyCells && index === 1) {
                            return (React.createElement("div", { style: style },
                                React.createElement("div", { className: "filters-and-tags" },
                                    React.createElement(CheckBox, { checked: columnFilterLocal.showEmptyCells, action: function () { return changeFilterItem(null); }, label: L('(Blank cells)'), css: { marginRight: '10px' } }))));
                        }
                        else {
                            var itemLabel_1 = columnFilterLocal.sortedValues[index - displayDataOffset];
                            return (React.createElement("div", { style: style },
                                React.createElement("div", { className: "filters-and-tags" },
                                    React.createElement(CheckBox, { checked: !!columnFilterLocal.showValues[itemLabel_1], action: function () { return changeFilterItem(itemLabel_1); }, label: valueFormatter(itemLabel_1), css: { marginRight: '10px' } }),
                                    dataContext === ColumnMetaDataContext.IDENTIFIER &&
                                        tableTagId !== undefined && (React.createElement(TagsHandler, { targetTagIds: detectedTagMap === null || detectedTagMap === void 0 ? void 0 : detectedTagMap[itemLabel_1], targetTagsHandler: targetTagsHandler.bind(null, itemLabel_1), tagData: tagData, parentTableTagId: tableTagId, canUpdateTags: importJobEditable && !!manualMapping })))));
                        }
                    })))),
        React.createElement(ModalFooter, { done: saveChanges })));
}
function TagsHandler(_a) {
    var e_5, _b;
    var _this = this;
    var targetTagIds = _a.targetTagIds, targetTagsHandler = _a.targetTagsHandler, tagData = _a.tagData, parentTableTagId = _a.parentTableTagId, canUpdateTags = _a.canUpdateTags;
    var L = useLanguage().L;
    var createTag = useTagActions().createTag;
    var targetTags = [];
    try {
        for (var _c = __values(targetTagIds !== null && targetTagIds !== void 0 ? targetTagIds : []), _d = _c.next(); !_d.done; _d = _c.next()) {
            var targetTagId = _d.value;
            var targetTag = tagData.tagById[targetTagId];
            if (targetTag !== undefined && targetTag.type === TagType.Dimension) {
                targetTags.push(targetTag);
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_5) throw e_5.error; }
    }
    var createAndSelectTag = function (tagName) { return __awaiter(_this, void 0, void 0, function () {
        var newTag, newTargetTags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createTag({
                        name: tagName,
                        ParentId: parentTableTagId,
                        type: TagType.Dimension,
                    })];
                case 1:
                    newTag = _a.sent();
                    if (newTag !== null) {
                        newTargetTags = __spreadArray(__spreadArray([], __read((targetTagIds !== null && targetTagIds !== void 0 ? targetTagIds : [])), false), [newTag.id], false);
                        targetTagsHandler(newTargetTags);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var selectTag = function (tagId) {
        var newTargetTags = __spreadArray(__spreadArray([], __read((targetTagIds !== null && targetTagIds !== void 0 ? targetTagIds : [])), false), [tagId], false);
        targetTagsHandler(newTargetTags);
    };
    var removeTag = function (tagId) {
        var newTargetTags = (targetTagIds !== null && targetTagIds !== void 0 ? targetTagIds : []).filter(function (tId) { return tagId !== tId; });
        targetTagsHandler(newTargetTags);
    };
    return (React.createElement("div", { className: "tagHandler" },
        React.createElement(Tags, { singleLine: true, canUpdate: canUpdateTags, create: createAndSelectTag, select: selectTag, remove: removeTag, tags: targetTags, filterByParentIds: [parentTableTagId], filterByTypes: [TagType.Dimension], placeholder: L('Select dimensions') })));
}
export default withRoot(ColumnEditModal);
